module.exports = __webpack_public_path__ + "static/12-6275114800c0a6a26cb17311f7cdfe4f.jpg";